import JoinAsosWorldButton from "../../components/JoinAsosWorldButton/JoinAsosWorldButton";

export const getButtonRenderer = ({
  shouldShowJoinLoyaltyButton,
  renderAddToBag,
  productIsInStock,
  variantIsInStock,
}) => {
  const shouldShowLoyaltyButton =
    shouldShowJoinLoyaltyButton &&
    productIsInStock &&
    variantIsInStock !== false;

  if (shouldShowLoyaltyButton) {
    return <JoinAsosWorldButton />;
  }

  return renderAddToBag();
};
